import { css } from '@emotion/react'
import { Heading, HFlow, Tag, Text, VFlow } from 'bold-ui'
import { useAlert } from 'components/alert'
import { Box } from 'components/Box'
import { Form, FormRenderProps, SubmitButton } from 'components/form'
import { confirm } from 'components/modals/confirm'
import { useConfiguracoes } from 'hooks/configuracoes'

interface ConfiguracaoBooleanBoxProps {
  title: string
  description: string
  habilitado: boolean
  modalBody: string
  successMsgHabilitado: string
  successMsgDesabilitado: string
  onMutation: (novoEstado: boolean) => Promise<any>
}

export function ConfiguracaoBooleanBox(props: Readonly<ConfiguracaoBooleanBoxProps>) {
  const { title, description, habilitado, modalBody, successMsgHabilitado, successMsgDesabilitado, onMutation } = props

  const alert = useAlert()
  const { update } = useConfiguracoes()

  const executeChange = async (msg: string) => {
    await onMutation(!habilitado)
    alert('success', msg)
    await update()
  }

  const handleSubmit = async () => {
    if (!habilitado) {
      return confirm({
        title: 'Deseja habilitar?',
        body: modalBody,
        confirmLabel: 'Habilitar mesmo assim',
        onConfirm: async () => {
          await executeChange(successMsgHabilitado)
        },
      })()
    }

    return executeChange(successMsgDesabilitado)
  }

  const renderForm = (formProps: FormRenderProps) => (
    <Box style={styles.box}>
      <HFlow>
        <VFlow vSpacing={0.5}>
          <Heading level={3}>{title}</Heading>
          <Text>{description}</Text>
          <SubmitButton kind='primary' size='small' handleSubmit={formProps.handleSubmit}>
            {habilitado ? 'Desabilitar' : 'Habilitar'}
          </SubmitButton>
        </VFlow>
        {habilitado ? (
          <Tag type='success' icon='checkCircleFilled'>
            Habilitado
          </Tag>
        ) : (
          <Tag icon='banFilled'>Desabilitado</Tag>
        )}
      </HFlow>
    </Box>
  )

  return <Form onSubmit={handleSubmit} render={renderForm} />
}

const styles = {
  box: css`
    margin-top: 1rem;
  `,
}
